<template>
  <section role="region" class="self-service-section">
    <div class="wrapper">
      <div class="text">
        <TheSecondHead chipText="Na palma da mão" titleText="Autosserviço" />
        <p class="paragraph">
          Nosso canal de autosserviço está à disposição para entregar os mais variados tipos de informações complementares
          aos clientes.
        </p>
        <div class="white-box">
          <img src="@/assets/icons/business/full-channel/checkQuadrado.png"
            alt="Quadrado azul com cirulo lilás e símbolo checado em branco" loading="lazy" />
          <p>Boletos, status de transações, contratos e muito mais!</p>
        </div>
      </div>
      <div class="image" :style="getMobilepBackground(counter)">
        <div class="image-box-1" v-show="starting || counter == 1">
          <picture class="image-component">
            <source srcset="@/assets/images/business/animation/portal01.png" media="(min-width: 834px">
            <source srcset="@/assets/images/business/animation/mao01.png" media="(max-width: 833)">
            <img alt="Print 1 do autosserviço" src="@/assets/images/business/animation/mao01.png" />
          </picture>
        </div>
        <div class="image-box-2" v-show="starting || counter == 2">
          <picture class="image-component">
            <source srcset="@/assets/images/business/animation/portal02.png" media="(min-width: 834px">
            <source srcset="@/assets/images/business/animation/mao02.png" media="(max-width: 833)">
            <img alt="Print 2 do autosserviço" src="@/assets/images/business/animation/mao02.png" />
          </picture>
        </div>
        <div class="image-box-3" v-show="starting || counter == 3">
          <picture class="image-component">
            <source srcset="@/assets/images/business/animation/portal03.png" media="(min-width: 834px">
            <source srcset="@/assets/images/business/animation/mao03.png" media="(max-width: 833)">
            <img alt="Print 3 do autosserviço" src="@/assets/images/business/animation/mao03.png" />
          </picture>
        </div>
        <div class="image-box-4" v-show="starting || counter == 4">
          <picture class="image-component">
            <source srcset="@/assets/images/business/animation/portal04.png" media="(min-width: 834px">
            <source srcset="@/assets/images/business/animation/mao04.png" media="(max-width: 833)">
            <img alt="Print 4 do autosserviço" src="@/assets/images/business/animation/mao04.png" />
          </picture>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'

const interval = ref<any>();
const counter = ref<number>(1);
const starting = ref<boolean>(true);

const getMobilepBackground = (itemCounter: number) => {
  let numberPath = itemCounter;
  if (typeof window !== "undefined" && window.innerWidth < 834) {
    return `background-image: url(/images/business/animation/mao0${numberPath}.png);`
  }
  return '';
}

onMounted(() => {
  interval.value = setInterval(() => {
    if (counter.value >= 4) {
      counter.value = 1;
    } else {
      counter.value = counter.value + 1;
    }
  }, 3000);

  starting.value = false;
})

onBeforeUnmount(() => {
  clearInterval(interval.value);
})
</script>

<style lang="scss">
@use "@/styles/variables" as *;

.self-service-section {
  background-color: $greyLight;
  max-width: none;

  .wrapper {
    display: flex;
    flex-direction: column;

    .text {
      padding: 40px 22px 0px 20px;
      text-align: center;

      .headline {
        .title {
          margin: 16px 0px;
          font-size: 40px;
          line-height: 110%;
        }
      }

      .paragraph {
        width: 93%;
        margin: 0 auto;
      }

      .white-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        column-gap: 15px;
        margin: 24px 0px 25px;
        padding: 19px 40px 20px 19px;
        border-radius: 18px;
        background: $white;
        box-shadow: 2px 2px 6px 0px rgba(0, 0, 0, 0.10);
        text-align: start;
      }
    }

    .image {
      margin: 0 auto;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      margin-bottom: -0.19px;

      .image-component {
        vertical-align: bottom;
        -webkit-animation-name: fade-in;
        animation-name: fade-in;
        -webkit-animation-duration: 1s;
        animation-duration: 1s;
        -webkit-animation-timing-function: ease-in-out;
        animation-timing-function: ease-in-out;

        img {
          vertical-align: bottom;
        }
      }
    }

    @media screen and (min-width: 834px) and (max-width: 959px) {
      .text {
        max-width: 240px;

        .white-box {
          img {
            display: none;
          }
        }
      }
    }

    @media screen and (min-width: 960px) and (max-width: 1199px) {
      .text {
        max-width: 330px;

        .paragraph {
          width: 70%;
        }

        .white-box {
          margin-top: 122px;
        }
      }
    }

    @media screen and (min-width: 834px) and (max-width: 1199px) {
      padding: 68px 32px 0px;
      align-items: flex-end;
      column-gap: 67px;

      .text .white-box {
        margin-bottom: 67px;
      }

      .image {
        margin-bottom: 0px;
      }
    }

    @media screen and (min-width: 834px) {
      flex-direction: row;

      .text {
        text-align: start;
        padding: 0;

        .paragraph {
          margin: 0px;
        }
      }

      .image {
        background-color: transparent;
        width: unset;
        height: unset;

        .image-component img {
          position: initial;
          vertical-align: bottom;
        }
      }
    }

    @media screen and (min-width: 960px) {
      max-width: 1030px;
      margin: 0 auto;
    }

    @media screen and (min-width: 1200px) {
      align-items: center;
      column-gap: 28px;
      padding-top: 68px;

      .text {
        width: 237px;

        .paragraph {
          width: 95%;
          margin-bottom: 80px;
        }

        .white-box {
          position: absolute;
          left: 65%;
          width: 330px;
          height: 119px;
          margin-top: -11.5rem;
          z-index: 99;
        }
      }

      .image {
        margin: 0px;
      }
    }
  }

  @media screen and (min-width: 834px) {
    .image-box-1 {
      background-image: url(@/assets/images/business/animation/portal04.png);
      background-size: 100%;
    }

    .image-box-2 {
      background-image: url(@/assets/images/business/animation/portal01.png);
      background-size: 100%;
    }

    .image-box-3 {
      background-image: url(@/assets/images/business/animation/portal02.png);
      background-size: 100%;
    }

    .image-box-4 {
      background-image: url(@/assets/images/business/animation/portal03.png);
      background-size: 100%;
    }
  }
}
</style>